import { FAKE, REAL, registerDependency } from '@cloudsuite/mosaic-shared/scripts/dependency-injection.js'


export const PLANNED_DELIVERIES_API = Symbol('PLANNED_DELIVERIES_API')

export interface PlannedDelivery {
  date: string
  status: string
  quantity: number
  sale_token: string
  sale_reference: string
  sale_detail: string
}

export interface PlannedDeliveriesApi {
  authorize: (ecommerceApiTokenEndpoint: string) => Promise<string | null>
  get: (ecommerceApiTokenEndpoint: string, storefrontEndpoint: string) => Promise<PlannedDelivery[]>
}

export class PlannedDeliveriesRequest {
  endpointUrl: URL
  method = 'GET' as const
  headers: HeadersInit = {
    'Accept': 'application/json',
    'Authorization': 'Bearer huppeluplup',
  }

  constructor(endpoint: string) {
    this.endpointUrl = new URL(endpoint, window.location.href)
  }
}

@registerDependency(FAKE, PLANNED_DELIVERIES_API)
export class FakePlannedDeliveriesApi implements PlannedDeliveriesApi {
  response: Promise<PlannedDelivery[]> = Promise.resolve([])
  requests: PlannedDeliveriesRequest[] = []

  changeResponse = (response: PlannedDelivery[]) => {
    this.response = Promise.resolve(response)
  }

  authorize = async (ecommerceApiTokenEndpoint: string): Promise<string> => {
    return Promise.resolve(ecommerceApiTokenEndpoint)
  }

  get = (ecommerceApiTokenEndpoint: string, storefrontEndpoint: string): Promise<PlannedDelivery[]> => {
    ecommerceApiTokenEndpoint
    const request = new PlannedDeliveriesRequest(storefrontEndpoint)
    this.requests.push(request)
    return this.response
  }
}


@registerDependency(REAL, PLANNED_DELIVERIES_API)
export class RealPlannedDeliveriesApi implements PlannedDeliveriesApi {
  private token: string | null = null

  setToken = (token: string) => {
    this.token = token
  }

  authorize = async (ecommerceApiTokenEndpoint: string): Promise<string | null> => {
    if (this.token) {
      return this.token
    }

    const response = await fetch(
      ecommerceApiTokenEndpoint,
      {
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
        },
        credentials: 'include'
      }
    )
    if ([401, 403].includes(response.status)) {
      console.warn(`Failed to fetch Storefront API token: ${response.status} (${response.statusText})`)

      throw new Error(`${response.status} (${response.statusText})`)
    }

    const responseJson = await response.json()
    this.token = responseJson.token

    return this.token
  }

  get = async (ecommerceApiTokenEndpoint: string, storefrontEndpoint: string): Promise<PlannedDelivery[]> => {
    await this.authorize(ecommerceApiTokenEndpoint)

    const authorizationHeader = {
      'Authorization': `Bearer ${this.token}`,
    }

    const response = await fetch(storefrontEndpoint, {
      headers: {
        'Accept': 'application/json',
        ...authorizationHeader,
      },
    })

    return response.json()
  }
}
